// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Like from '../_raw/ui/icon_like.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Like);
